import { Link } from "react-router-dom";
import { WA_LINK } from "@/lib/site";

const LINKS = [
  { label: "Serviços", href: "#servicos" },
  { label: "Segurança", href: "#seguranca" },
  { label: "Portfólio", href: "#portfolio" },
  { label: "Cobertura", href: "#cobertura" },
];

export const Nav = () => (
  <header
    data-testid="main-nav"
    className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-2xl"
  >
    <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
      <a href="#top" data-testid="nav-logo" className="flex items-center gap-2">
        <span className="h-3 w-3 bg-krono" aria-hidden="true" />
        <span className="font-display text-xl font-black tracking-tighter">KRONO</span>
      </a>
      <nav className="hidden items-center gap-8 md:flex">
        {LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={`nav-link-${l.label.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")}`}
            className="font-mono text-xs uppercase tracking-[0.2em] text-white/60 transition-colors hover:text-krono"
          >
            {l.label}
          </a>
        ))}
        <Link
          to="/conteudo"
          data-testid="nav-link-conteudo"
          className="font-mono text-xs uppercase tracking-[0.2em] text-white/60 transition-colors hover:text-krono"
        >
          Conteúdo IG
        </Link>
      </nav>
      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="nav-cta-whatsapp"
        className="bg-krono px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-[0.15em] text-black transition-colors hover:bg-krono-hover"
      >
        Orçamento
      </a>
    </div>
  </header>
);
